<template>
  <right-panel :datas="accountInfo" ref="rightPanel" @onClose="onClose">
    <div slot="header" v-if="accountInfo">
      {{!accountInfo.mobile ? attrText.bindMobile : attrText.changeMobile}}
    </div>
    <div slot="content" class="wrapper-padding">
      <el-form ref="mobileForm" label-width="120px" class="demo-ruleForm">
        <el-form-item :label="attrText.mobileNum">
          <el-input v-model="changePhoneNumForm.mobile" :disabled="changePhoneNumForm.disMobile" @change="checkMobile"
                    :placeholder="attrText.pleaseinputMobil"></el-input>
        </el-form-item>
        <!--<el-form-item :label="attrText.verifyCode">-->
        <!--<el-col :span="17">-->
        <!--<el-input v-model="changePhoneNumForm.code" :disabled="changePhoneNumForm.canWriteCode" @change="checkCode" :placeholder="attrText.pleaseinputverifyCode"></el-input>-->
        <!--</el-col>-->
        <!--<el-col :span="7" class="verify-code">-->
        <!--<el-button type="text" :disabled="changePhoneNumForm.canClick" @click="getCode()">{{text}}</el-button>-->
        <!--</el-col>-->
        <!--</el-form-item>-->
      </el-form>
    </div>
    <div slot="footer" class="detail-btn">
      <div class="btn-wrapper">
        <el-button type="primary" :disabled="changePhoneNumForm.canSubmit" @click="onSubmitVerify()">
          <translate>Save</translate>
        </el-button>
        <el-button @click="$refs.rightPanel.onClose()">
          <translate>Cancel</translate>
        </el-button>
      </div>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'AccountChangeMobile',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        accountInfo: null,
        changePhoneNumForm: {
          mobile: '',
          code: '',
          time: 0,
          canWriteCode: true,
          disMobile: false,
          canSubmit: true,
          canClick: true
        }
      }
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      },
      text () {
        return this.changePhoneNumForm.time > 0 ? this.changePhoneNumForm.time + 's' + this.$gettext('Retry After') : this.$gettext('Send Verify Code')
      }
    },
    methods: {
      // 提取翻译文本
      getTransitionText () {
        return {
          'bindMobile': this.$gettext('Bind Mobile'),
          'changeMobile': this.$gettext('Change Mobile'),
          'mobileNum': this.$gettext('Mobile Number'),
          'verifyCode': this.$gettext('Verify Code'),
          'pleaseinputMobil': this.$gettext('Please input mobile number'),
          'pleaseinputverifyCode': this.$gettext('Please input verify code')
        }
      },
      // 获取手机验证码
//      getCode () {
//        let data = {
//          data: {
//            'mobile': this.changePhoneNumForm.mobile
//          }
//        }
//        // update current account mobille
//        this.$store.dispatch(STORE_CONST.ACCOUNT.UPDATE, data).then(res => {
//          this.changePhoneNumForm.disMobile = true
//          this.changePhoneNumForm.canWriteCode = false
//          // send code
//          this.$store.dispatch(STORE_CONST.ACCOUNT.CODE).then(res => {
//            this.run()
//          })
//        })
//      },
      // 提交验证手机验证码
      onSubmitVerify () {
        let data = {
          data: {
            'mobile': this.changePhoneNumForm.mobile
          }
        }
        // update current account mobille
        this.$store.dispatch(STORE_CONST.ACCOUNT.UPDATE, data).then(res => {
          this.$emit('callback', this.$store.getters.account.id)
          this.onClose()
          this.$notify({
            message: this.$gettext('Change successful'),
            type: 'success'
          })
        }).catch(() => {
          this.$notify.error({
            message: this.$gettext('Verification code error')
          })
          this.$refs['rightPanel'].onSubmitErr()
        })
      },
//      onSubmitVerify () {
//        let data = {
//          data: {
//            'code': this.changePhoneNumForm.code
//          }
//        }
//        this.$store.dispatch(STORE_CONST.ACCOUNT.VERIFY, data).then(res => {
//          if (res.result === false) {
//            this.$notify.error({
//              message: this.$gettext('Verification code error')
//            })
//            this.$refs['rightPanel'].onSubmitErr()
//          } else {
//            this.$emit('callback')
//            this.onClose()
//            this.$notify({
//              message: this.$gettext('Modify the phone number is successful'),
//              type: 'success'
//            })
//          }
//        })
//      },
      // 关闭侧滑
      onClose () {
        this.accountInfo = null
        this.$emit('onClosePanel')
      },
      // count down
//      run () {
//        this.changePhoneNumForm.time = 60
//        this.canWriteCode = false
//        this.timer()
//      },
//      timer () {
//        if (this.changePhoneNumForm.time > 0) {
//          this.canClick = true
//          this.changePhoneNumForm.time--
//          this.changePhoneNumForm.interval = setTimeout(this.timer, 1000)
//        } else {
//          this.canClick = false
//        }
//      },
      checkMobile (val) {
        if (/^1[34578]\d{9}$/.test(val) && val !== this.accountInfo.mobile) {
          this.changePhoneNumForm.canSubmit = false
        } else {
          this.changePhoneNumForm.canSubmit = true
        }
      },
      // 匹配验证码
      checkCode (val) {
        if (/^\d{6}$/.test(val)) {
          this.changePhoneNumForm.canSubmit = false
        } else {
          this.changePhoneNumForm.canSubmit = true
        }
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.accountInfo) {
            this.accountInfo = null
            setTimeout(() => {
              this.accountInfo = this.items
            }, 300)
          } else {
            this.accountInfo = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  .verify-code {
    padding-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// account-change-mobile.vue?10a26492